export default __webpack_public_path__ + "static/media/video_1.52e8933b.mp4";